// 券種まとめあり、なしごとに区別できるようフラグを追加して必要な情報を抽出
export const classifyMasterBookSets = (masterBookSets) => {
  try {
    // APIコールまだでmasterBookSetsが空の場合は、空の配列を返す
    if (masterBookSets.length === 0) return [];

    return masterBookSets.map((masterBookSet) => {
      if (masterBookSet.master_books.length == 0) {
        console.log("No masterBook !!!");
        return;
      }
      var isSet;
      if (masterBookSet.master_books.length === 1) {
        isSet = false; // 券種まとめなし
      } else {
        isSet = true; // 券種まとめあり
      }
      const referenceMasterBook = masterBookSet.reference_master_book;

      // デバッグ用。基本nullになることはないが、データ不整合を検知しやすくするため
      if (referenceMasterBook == null) {
        throw `referenceMasterBook is null set_id: ${masterBookSet.id}`;
      }
      return {
        area: referenceMasterBook.master_areas[0].name,
        id: referenceMasterBook.id,
        name: masterBookSet.name,
        display_price: masterBookSet.display_price,
        content: {
          ticket_image_url: referenceMasterBook.content.ticket_image_url,
        },
        purchase_available: referenceMasterBook.purchase_available,
        master_book_set_id: masterBookSet.id,
        is_set: isSet,
      };
    });
  } catch (e) {
    console.log("Error in classifyMasterBookSets: ", e);
    throw e;
  }
};
